<template>
    <div class="guided-stepper">
        <div
            v-for="(step, idx) in steps"
            :key="step.id"
            class="guided-stepper__item"
            :class="{
                'guided-stepper__item--active': currentStep === step.id,
                'guided-stepper__item--done': currentStep > step.id,
                'guided-stepper__item--clickable': allowClick,
            }"
            @click="allowClick && $emit('select', step.id)"
        >
            <div class="guided-stepper__circle">
                <span v-if="currentStep > step.id" class="material-symbols-outlined">check</span>
                <span v-else>{{ step.id }}</span>
            </div>
            <div class="guided-stepper__label">
                <div class="guided-stepper__label-title">{{ step.title }}</div>
                <div class="guided-stepper__label-sub">{{ step.subtitle }}</div>
            </div>
            <div v-if="idx < steps.length - 1" class="guided-stepper__connector"></div>
        </div>
    </div>
</template>

<script setup>
defineProps({
    currentStep: { type: Number, required: true },
    allowClick: { type: Boolean, default: true },
});

defineEmits(['select']);

const steps = [
    { id: 1, title: 'Overview', subtitle: 'Where is this learner?' },
    { id: 2, title: 'Build Program', subtitle: 'Preferences, syllables & word ideas' },
    { id: 3, title: 'Program Targets', subtitle: 'Your shaping plan' },
];
</script>

<style scoped>
.guided-stepper {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 10px;
    padding: 20px 24px;
    background: #fff;
    border-radius: 12px;
    box-shadow: 0 2px 8px rgba(114, 92, 255, 0.06);
    margin-bottom: 24px;
}

.guided-stepper__item {
    position: relative;
    display: flex;
    align-items: center;
    gap: 12px;
    flex: 1;
    min-width: 0;
}

.guided-stepper__item--clickable {
    cursor: pointer;
}

.guided-stepper__circle {
    flex-shrink: 0;
    width: 36px;
    height: 36px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #ededed;
    color: #888;
    font-weight: 600;
    transition: background 0.2s, color 0.2s;
}

.guided-stepper__item--active .guided-stepper__circle {
    background: #725CFF;
    color: #fff;
    box-shadow: 0 0 0 4px rgba(114, 92, 255, 0.15);
}

.guided-stepper__item--done .guided-stepper__circle {
    background: #36C27A;
    color: #fff;
}

.guided-stepper__label {
    min-width: 0;
}

.guided-stepper__label-title {
    font-weight: 600;
    font-size: 14px;
    color: #222;
    line-height: 1.2;
}

.guided-stepper__item--active .guided-stepper__label-title {
    color: #725CFF;
}

.guided-stepper__label-sub {
    font-size: 12px;
    color: #888;
    margin-top: 2px;
}

.guided-stepper__connector {
    flex: 1;
    height: 2px;
    background: #ededed;
    margin: 0 8px;
}

.guided-stepper__item--done .guided-stepper__connector {
    background: #36C27A;
}

@media (max-width: 768px) {
    .guided-stepper {
        flex-direction: column;
        align-items: stretch;
        gap: 12px;
    }

    .guided-stepper__connector {
        display: none;
    }
}
</style>
